export default __webpack_public_path__ + "static/media/05-inputs-min.cbb70930.png";